<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item>
					<el-date-picker v-model="filterForm.date" class="w100" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
		        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
				<el-button type="primary" size="mini" @click="isdialog=true" data-name="添加学生">{{$t('index.add_student')}}</el-button>
	        </div>
		</div>
		<div>
			<el-table :data="info_list" size="mini" border :span-method="objectSpanMethod">
				<el-table-column align="center" :label="$t('course_index.date')" data-name="日期">
					<template slot-scope="{row}">
						{{getTime_us(row.date_time,'mmddyyyy')}}
					</template>
				</el-table-column>
				<el-table-column align="center" :label="$t('course_index.time')" data-name="时间" width="130">
					<template slot-scope="{row}">
						{{getTime_us(row.start_time,'hh:ii')}} - {{getTime_us(row.end_time,'hh:ii')}}
					</template>
				</el-table-column>
				<el-table-column align="center" :label="$t('course_index.status')" data-name="状态">
					<template slot-scope="{row}">
						<span class="red" v-if="row.status==2" data-name="已购买">{{$t('course_private.purchased')}}</span>
						<span class="green" v-if="row.status==3" data-name="已确认">{{$t('course_private.confirmed')}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_name" align="center" :label="$t('student_list.parent_name')" data-name="用户"></el-table-column>
				<el-table-column prop="email" align="center" :label="$t('student_list.email')" data-name="邮箱"></el-table-column>
				<el-table-column prop="tel" align="center" :label="$t('student_list.tel')" data-name="电话"></el-table-column>
				<el-table-column prop="children_name" align="center" :label="$t('student_list.name')" data-name="学生"></el-table-column>
				<el-table-column prop="age" align="center" :label="$t('student_list.age')" data-name="年龄"></el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')" data-name="备注"></el-table-column>
				<el-table-column prop="children_status" align="center" :label="$t('student_list.children_status')" data-name="学生状态">
					<template slot-scope="{row}">
						{{$t('student_list.status'+row.children_status)}}
					</template>
				</el-table-column>
				<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="400">
					<template slot-scope="scope">
						<el-button size="mini" type="info"  @click="del(scope.row)" data-name="删除">{{$t('virtual.del_student')}}</el-button>
						<el-button size="mini" type="primary" @click="zuoyu(scope.row)" data-name="作业">{{$t('virtual.task')}}</el-button>
						<el-button size="mini" type="primary" @click="communication_f(scope.row)" data-name="师生交流">{{$t('virtual.chat')}}</el-button>
						<el-button size="mini" type="primary"  @click="remarks_ff(scope.row)">{{$t('feedback_index.remarks')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div>
		<el-dialog :title="$t('virtual.chat')" width="1000px" :close-on-click-modal="false" :visible="communication_is" @close="communication_is = false">
			<communication course_type="private" type="private" :course_id="String(communi.id)"></communication>
		</el-dialog>
		<el-dialog :title="$t('virtual.task')" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form class="zuoy" size="mini" label-position="top">
				<el-row v-if="homework.title">
					<div class="p1">{{$t('virtual.teacher_task')}}</div>
					<el-col :span="24">
						 <!-- :label="$t('virtual.task_name')" -->
						<el-form-item data-name="标题">
							<div class="font_input">{{homework.title}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<!-- :label="$t('virtual.task_content')" -->
						<el-form-item  data-name="内容">
							<div class="font_input">{{homework.content}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<!-- :label="$t('virtual.task_file')" -->
						<el-form-item  v-if="homework.filename&&homework.filename.length" data-name="附件">
							<div class="font_input">
								<div class="img_img" v-for="(item,index) in homework.filename" :key="index">
									<video v-if="item.type=='video'" :src="item.url" loop="loop" controls="controls" poster="" class="video"></video>
									<img v-else-if="item.type=='image'" :src="item.url" class="video" alt="">
									<iframe v-else-if="item.type=='iframe'" :src="item.url"  frameborder="0" class="video"></iframe>
									<div v-else-if="item.type=='html'" v-html="item.url" class="video"></div>
									<el-input v-else class="shangchuan" :value="item.url">
										<el-button slot="append" data-name="下载" @click="download(item.url)">{{$t('virtual.download')}}</el-button>
									</el-input>
								</div>
							</div>
						</el-form-item>
					</el-col>
					<div class="p1 p2">{{$t('virtual.student_task')}}</div>
				</el-row>
				<div class="p1" v-else>{{$t('virtual.teacher_on_task')}}</div>
				<el-row v-for="(item,index) in list" :key="index">
					<el-col :span="24">
						<!-- :label="$t('virtual.task_content')" -->
						<el-form-item  data-name="内容">
							<div class="font_input">{{item.work}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<!-- :label="$t('virtual.task_file')" -->
						<el-form-item  v-if="item.filename&&item.filename.length" data-name="附件">
							<div class="font_input">
								<div class="img_img" v-for="(item,index) in item.filename" :key="index">
									<video v-if="item.type=='video'" :src="item.url" loop="loop" controls="controls" poster="" class="video"></video>
									<img v-else-if="item.type=='image'" :src="item.url" class="video" alt="">
									<iframe v-else-if="item.type=='iframe'" :src="item.url"  frameborder="0" class="video"></iframe>
									<div v-else-if="item.type=='html'" v-html="item.url" class="video"></div>
									<el-input v-else class="shangchuan" :value="item.url">
										<el-button slot="append" data-name="下载" @click="download(item.url)">{{$t('virtual.download')}}</el-button>
									</el-input>
								</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="children_work.content">
					<div class="p1 p2">{{$t('virtual.teacher_ratify_task')}}</div>
					<el-col :span="24">
						<!-- :label="$t('virtual.task_content')" -->
						<el-form-item  data-name="内容">
							<div class="font_input">{{children_work.content}}</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
		<private_student_list :isdialog="isdialog" :id="id" @guanbitanchu="guanbitanchu"></private_student_list>
		<!-- 备注 -->
		<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible1" @close="editFormVisible1 = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm1">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
							<el-input v-model="editForm.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible1 = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit1('editForm1')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import communication from '../../components/communication.vue'
import private_student_list from '../../components/private_student_list.vue'
export default {
	components: {
		communication,
		private_student_list,
	},
	computed: {
		editFormRules() {
			return {
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.cn') + this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.en') + this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('dictionary.list_code'),
					trigger: 'blur'
				}],
				remarks: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('feedback_index.remarks'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			id:'',
			filterForm:{
				status:'1',
				course_id:'',
				date:null,
			},
			info_list:[],
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
			communication_is:false,
			communi:{},
			editFormVisible: false,

			isdialog:false,
			homework:{},
			list:[],
			workdetail:{},
			children_work:{},
			editFormVisible1: false,
			editForm:{
				id:'',
				remarks:'',
			}

		}
	},
	// 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "privateCoursePlanInfo";
			var date_time=this_.date_time(1);
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				id:this_.id,
				date_time:date_time.join(','),
			}
			if (this_.filterForm.date) {
				datas['start_time']=Math.round(this_.filterForm.date[0]/1000);
				datas['end_time']=Math.round(this_.filterForm.date[1]/1000);
			}
			this_.$post(url, datas).then((res) => {
				this_.info_list = res.list;
				this_.pages.count = res.sum;
				this_.spanArr=[];
				this_.getSpanArr(this_.info_list);
			})
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				const _row = this.spanArr[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		date_time(s){
			var dateobj = new Date();
			let year = dateobj.getFullYear();
			let month = dateobj.getMonth();
			let date = dateobj.getDate();
			let hour = dateobj.getHours();
			let minute = dateobj.getMinutes();
			let second = dateobj.getSeconds();
			var datetime_array=[];
			for (var i = 0; i < s; i++) {
				
				datetime_array[i]= Math.round(new Date(year,month,(date+i+1),0,0,0).getTime()/1000);
			}
			return datetime_array;
		},
		getSpanArr(data) {
			// data就是我们从后台拿到的数据
			for (var i = 0; i < data.length; i++) {
				if (i === 0) {
					this.spanArr.push(1);
					this.pos = 0;
				} else {
					// 判断当前元素与上一个元素是否相同
					if (data[i].date_time === data[i - 1].date_time) {
						this.spanArr[this.pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						this.pos = i;
					}
				}
			}
		},
		communication_f(data){
			this.communi=data;
			this.communication_is=true;
		},
		zuoyu(data){
			var this_ = this;
			var url = "privateAdminChildWorkList";
			var datas = {
				plan_id:data.id,
			}
			this_.$post(url, datas).then((res) => {
				this_.info = res;
				if (res.homework) {
					this_.homework = res.homework;
					if (res.homework.filename) {
						this_.homework['filename'] = JSON.parse(res.homework.filename);
					}
				}
				var list= res.list;
				list.forEach(function(e,i) {
					if (e.filename) {
						e['filename']=JSON.parse(e.filename);
					}
				});
				this_.list = list;
				this_.children_work = res.children_work;
				this_.editFormVisible=true;
			})
		},
		guanbitanchu(e){
			this.isdialog=false;
			if (e) {
				this.handleCurrentChange(1);
			}
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "deletePrivateChild";
			var datas = {
				classes_id:data.classes_id	
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},

		remarks_ff(data){
			this.editForm.id=data.classes_id;
			this.editForm.remarks=data.remarks;
			this.editFormVisible1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'classes',
						field: 'remarks',
						value: this_.editForm.remarks,
						pk_id: this_.editForm.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
.red{
	color: #fff;
	background-color: red;
}
.green{
	color: #fff;
	background-color: green;
}
.filter-panel{
	float: left;
	width:calc( 100% - 200px );
}
.zuoy .p1{
	font-size: 20px;
}
.zuoy .p2{
	margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/index.vue